import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { BreadcrumbsV2 } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphsRenderer } from '../../../components';
import useLayoutVariables from '../../../hooks/useLayoutVariables';
import type { NodeBasicPage as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface BasicPageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const NodeBasicPage: React.FC<BasicPageProps> = ({ entity, className }) => {
  const {
    breadcrumbsColClasses,
    heroTextColClasses,
  } = useLayoutVariables('basicPage');

  const classes = classNames('Node', 'NodeBasicPage', className);
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeBasicPage__hero">
        <Container>
          <div className="row">
            <div className={breadcrumbsColClasses}>
              <BreadcrumbsV2 />
            </div>
          </div>
          <div className="row">
            <div className={heroTextColClasses}>
              <h1 className="NodeBasicPage__title" itemProp="title">
                {title}
              </h1>

              {body && (
                <WysiwygField
                  className="NodeBasicPage__body body--large"
                  property="schema:text"
                  html={body}
                />
              )}
            </div>
          </div>
        </Container>
      </div>

      <ParagraphsRenderer className="NodeBasicPage__paragraphs" paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeBasicPage;
